import { useContext, type ReactNode } from 'react'
import { FigureNumberContext } from './FigureNumberContext'

/**
 * FigureFrame — a bordered chart well plus a caption whose hierarchy reads as:
 * bold "Figure N." lead-in → caption in muted body → a quieter monospace
 * source credit (the source is a tool name / code identifier). The figure
 * number is omitted entirely when no FigureNumberContext is provided.
 */
export function FigureFrame({
  caption,
  source,
  children,
}: {
  caption: string
  source?: string
  children: ReactNode
}) {
  const n = useContext(FigureNumberContext)
  return (
    <figure className="report-figure my-4 break-inside-avoid">
      <div className="rounded-lg border border-border bg-card p-4">{children}</div>
      <figcaption className="mt-2.5 max-w-[70ch] text-sm leading-snug text-muted-foreground">
        {n != null && <span className="font-semibold text-foreground">Figure {n}. </span>}
        {caption}
        {source && (
          <span className="mt-1 block text-xs text-muted-foreground/80">
            Source: <span className="font-mono">{source}</span>
          </span>
        )}
      </figcaption>
    </figure>
  )
}
